/* ============================================================
   Telos Rx, Shopify Theme Interactivity
   Vanilla JS, no frameworks
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  /* ----------------------------------------------------------
     0. Mobile nav toggle
     Binds first and is wrapped in try/catch (like every block
     below) so a bug in an unrelated animation can never leave
     the hamburger button dead for the rest of the page view.
     ---------------------------------------------------------- */
  try {
  (function initMobileNav() {
    var burger = document.getElementById('nav-burger');
    var mobileMenu = document.getElementById('mobile-menu');
    if (!burger || !mobileMenu) return;

    burger.addEventListener('click', function () {
      var isOpen = mobileMenu.classList.contains('open');
      if (isOpen) {
        mobileMenu.classList.remove('open');
        burger.setAttribute('aria-expanded', 'false');
      } else {
        mobileMenu.classList.add('open');
        burger.setAttribute('aria-expanded', 'true');
      }
    });

    /* Category accordions: tap a category (e.g. Weight Loss) to expand its products. */
    mobileMenu.querySelectorAll('.nav-mobile-toggle').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        var sub = document.getElementById(btn.getAttribute('aria-controls'));
        if (sub) sub.hidden = expanded;
      });
    });

    /* Tap anywhere outside the open menu (and not the burger) to dismiss it. */
    document.addEventListener('click', function (e) {
      if (!mobileMenu.classList.contains('open')) return;
      if (mobileMenu.contains(e.target) || burger.contains(e.target)) return;
      mobileMenu.classList.remove('open');
      burger.setAttribute('aria-expanded', 'false');
    });
  })();
  } catch (e) { if (window.console) console.error('initMobileNav failed', e); }


  /* ----------------------------------------------------------
     1. Hero cycling text
     ---------------------------------------------------------- */
  try {
  (function initHeroCycle() {
    var el = document.getElementById('hero-cycle-text');
    if (!el) return;

    var raw = el.getAttribute('data-cycle');
    if (!raw) return;

    // Split on comma-space but keep "Managed together, not in silos." intact
    var words = [];
    var parts = raw.split('.,');
    for (var p = 0; p < parts.length; p++) {
      var w = parts[p].trim();
      if (p < parts.length - 1) w += '.';
      words.push(w);
    }
    if (!words.length) return;

    var index = 0;
    el.textContent = words[0];
    el.classList.add('in');
    el.classList.remove('out');

    function cycle() {
      var isFinal = index === words.length - 1;
      var hold = isFinal ? 2400 : 1500;

      setTimeout(function () {
        // Fade out
        el.classList.remove('in');
        el.classList.add('out');

        setTimeout(function () {
          // Advance to next word
          index = (index + 1) % words.length;
          el.textContent = words[index];

          // Update max-width for final line
          var nextIsFinal = index === words.length - 1;
          el.style.maxWidth = nextIsFinal ? '22ch' : 'none';

          // Fade in
          el.classList.remove('out');
          el.classList.add('in');

          // Continue the cycle
          cycle();
        }, 320);
      }, hold);
    }

    cycle();
  })();
  } catch (e) { if (window.console) console.error('initHeroCycle failed', e); }


  /* ----------------------------------------------------------
     1b. Typewriter, types, holds, deletes, cycles ([data-typewriter])
     ---------------------------------------------------------- */
  try {
  (function initTypewriter() {
    var els = document.querySelectorAll('[data-typewriter]');
    if (!els.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    Array.prototype.forEach.call(els, function (el) {
      var raw = el.getAttribute('data-typewriter');
      if (!raw) return;
      var words = raw.split('|').map(function (s) { return s.trim(); }).filter(Boolean);
      if (!words.length) return;

      el.textContent = '';
      var txt = document.createElement('span');
      txt.className = 'tw-text';
      var caret = document.createElement('span');
      caret.className = 'tw-caret';
      el.appendChild(txt);
      el.appendChild(caret);

      // Reduced motion / no-JS-fallback already handled: just show the first phrase.
      if (reduce) { txt.textContent = words[0]; return; }

      var wi = 0, ci = 0, deleting = false;
      function tick() {
        var word = words[wi];
        if (!deleting) {
          ci++;
          txt.textContent = word.slice(0, ci);
          if (ci >= word.length) { deleting = true; setTimeout(tick, 1700); }   // hold full phrase
          else setTimeout(tick, 60 + Math.random() * 48);                        // type speed (slight human jitter)
        } else {
          ci--;
          txt.textContent = word.slice(0, ci);
          if (ci <= 0) { deleting = false; wi = (wi + 1) % words.length; setTimeout(tick, 360); } // pause, next phrase
          else setTimeout(tick, 32);                                             // delete speed
        }
      }
      setTimeout(tick, 520);
    });
  })();
  } catch (e) { if (window.console) console.error('initTypewriter failed', e); }


  /* ----------------------------------------------------------
     1c. Count-up, numbers tick up to value on scroll-in ([data-countup])
     ---------------------------------------------------------- */
  try {
  (function initCountUp() {
    var els = document.querySelectorAll('[data-countup]');
    if (!els.length || !('IntersectionObserver' in window)) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    Array.prototype.forEach.call(els, function (el) {
      var text = (el.textContent || '').trim();
      var m = text.match(/^([^\d]*)([\d,]+(?:\.\d+)?)(.*)$/);
      if (!m) return;                                   // nothing numeric, leave it
      var prefix = m[1], numStr = m[2], suffix = m[3];
      var target = parseFloat(numStr.replace(/,/g, ''));
      var decimals = (numStr.split('.')[1] || '').length;
      var hasComma = numStr.indexOf(',') >= 0;
      function fmt(v) {
        var n = v.toFixed(decimals);
        if (hasComma) { var p = n.split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','); n = p.join('.'); }
        return prefix + n + suffix;
      }
      if (reduce) return;                               // leave the final value rendered
      // The real value stays in the page until the element is actually on screen, so crawlers,
      // AI answer engines and no-JS readers see the true number, never a placeholder "0".
      var done = false;
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting || done) return;
          done = true; obs.disconnect();
          el.textContent = fmt(0);
          var dur = 950, start = null;
          function step(ts) {
            if (start === null) start = ts;
            var p = Math.min((ts - start) / dur, 1);
            var eased = 1 - Math.pow(1 - p, 3);
            el.textContent = fmt(target * eased);
            if (p < 1) requestAnimationFrame(step); else el.textContent = fmt(target);
          }
          requestAnimationFrame(step);
        });
      }, { threshold: 0.4 });
      obs.observe(el);
    });
  })();
  } catch (e) { if (window.console) console.error('initCountUp failed', e); }


  /* ----------------------------------------------------------
     1d. Parallax, subtle scroll drift ([data-parallax="0.1"]).
         Uses the CSS `translate` property so it composes with any
         transform-based reveal/float instead of fighting it.
     ---------------------------------------------------------- */
  try {
  (function initParallax() {
    var els = document.querySelectorAll('[data-parallax]');
    if (!els.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;

    var items = Array.prototype.map.call(els, function (el) {
      return { el: el, speed: parseFloat(el.getAttribute('data-parallax')) || 0.1 };
    });
    var ticking = false;
    function update() {
      ticking = false;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      items.forEach(function (it) {
        var r = it.el.getBoundingClientRect();
        var offset = (r.top + r.height / 2) - vh / 2;     // distance of element centre from viewport centre
        it.el.style.translate = '0 ' + (offset * -it.speed).toFixed(1) + 'px';
      });
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  })();
  } catch (e) { if (window.console) console.error('initParallax failed', e); }


  /* ----------------------------------------------------------
     3. FAQ accordion
     ---------------------------------------------------------- */
  (function initFAQ() {
    var items = document.querySelectorAll('.faq-item');
    if (!items.length) return;

    items.forEach(function (item) {
      var btn = item.querySelector('.faq-btn');
      if (!btn) return;

      btn.addEventListener('click', function () {
        var isActive = item.classList.contains('active');

        // Close all items
        items.forEach(function (other) {
          other.classList.remove('active');
          var otherAnswer = other.querySelector('.faq-answer');
          var otherIcon = other.querySelector('.faq-icon');
          if (otherAnswer) otherAnswer.style.display = 'none';
          if (otherIcon) otherIcon.style.transform = 'none';
        });

        // If this item was not active, open it
        if (!isActive) {
          item.classList.add('active');
          var answer = item.querySelector('.faq-answer');
          var icon = item.querySelector('.faq-icon');
          if (answer) answer.style.display = 'block';
          if (icon) icon.style.transform = 'rotate(45deg)';
        }
      });
    });

    // Ensure the first item (with .active class) shows its answer on load
    var firstActive = document.querySelector('.faq-item.active');
    if (firstActive) {
      var answer = firstActive.querySelector('.faq-answer');
      var icon = firstActive.querySelector('.faq-icon');
      if (answer) answer.style.display = 'block';
      if (icon) icon.style.transform = 'rotate(45deg)';
    }
  })();


  /* ----------------------------------------------------------
     4. BMI Calculator
     ---------------------------------------------------------- */
  (function initBMICalc() {
    var feetInput = document.getElementById('bmi-feet');
    var inchesInput = document.getElementById('bmi-inches');
    var weightInput = document.getElementById('weight-input');
    var calcBtn = document.getElementById('calc-bmi-btn');
    var bmiDisplay = document.getElementById('bmi-display');
    var lossDisplay = document.getElementById('loss-display');
    var lossUnit = document.getElementById('loss-unit');
    var lossArrow = document.getElementById('loss-arrow');
    var weightSlider = document.getElementById('weight-slider');
    var weightPill = document.getElementById('weight-display-pill');
    var barsContainer = document.getElementById('calc-bars-container');
    var sliderTrack = document.getElementById('slider-track');
    var sliderThumb = document.getElementById('slider-thumb');

    if (!calcBtn || !bmiDisplay) return;

    var currentBmi = null;
    var currentLoss = null;
    var animFrame = null;

    function calculateBMI() {
      var ft = parseInt(feetInput.value) || 0;
      var inc = parseInt(inchesInput.value) || 0;
      var w = parseInt(weightInput.value) || parseInt(weightSlider.value) || 0;
      var totalInches = ft * 12 + inc;

      if (totalInches > 0 && w > 0) {
        var b = ((w / (totalInches * totalInches)) * 703).toFixed(1);
        currentBmi = parseFloat(b);

        // Update BMI display with color
        bmiDisplay.textContent = currentBmi;
        bmiDisplay.style.color = 'var(--ink)';

        // Calculate estimated weight loss (GLP-1: ~15-20%)
        var pct = b > 35 ? 0.20 : b > 30 ? 0.18 : b > 25 ? 0.15 : 0.12;
        var newLoss = Math.round(w * pct);
        animateCountUp(currentLoss || 0, newLoss);
        currentLoss = newLoss;

        // Show the arrow
        if (lossArrow) lossArrow.style.display = 'block';

        // Update loss unit color
        if (lossUnit) lossUnit.style.color = 'var(--ink-2)';

        // Update bar chart
        updateBars(newLoss);
      }
    }

    // Count-up animation for the loss display
    function animateCountUp(from, to) {
      if (animFrame) cancelAnimationFrame(animFrame);
      var dur = 800;
      var t0 = performance.now();

      function step(now) {
        var elapsed = now - t0;
        var progress = Math.min(elapsed / dur, 1);
        // Ease out cubic
        var eased = 1 - Math.pow(1 - progress, 3);
        var val = Math.round(from + (to - from) * eased);
        if (lossDisplay) {
          lossDisplay.textContent = val;
          lossDisplay.style.color = 'var(--ink)';
        }
        if (progress < 1) {
          animFrame = requestAnimationFrame(step);
        }
      }
      animFrame = requestAnimationFrame(step);
    }

    // Update bar chart heights
    function updateBars(loss) {
      if (!barsContainer) return;
      var bars = barsContainer.querySelectorAll('.calc-bar');
      var totalBars = bars.length;

      for (var b = 0; b < totalBars; b++) {
        var weekPct = (b + 1) / totalBars;
        // Typical GLP-1 curve: faster early, plateaus later
        var lossPct = loss ? Math.pow(weekPct, 0.6) : 0;
        var height = loss ? Math.max(8, lossPct * 100) : 12;

        // Color based on position
        var color;
        if (!loss) {
          color = 'var(--line-2)';
        } else if (b < 8) {
          color = 'var(--c300)';
        } else if (b < 16) {
          color = 'var(--c200)';
        } else {
          color = 'var(--c100)';
        }

        bars[b].style.height = height + '%';
        bars[b].style.background = color;
      }
    }

    // Calculate BMI button click
    calcBtn.addEventListener('click', calculateBMI);

    // Sync weight input and slider
    if (weightSlider && weightInput) {
      weightSlider.addEventListener('input', function () {
        var val = parseInt(weightSlider.value);
        weightInput.value = val;
        updateSliderVisual(val);
        if (weightPill) weightPill.textContent = val + 'lbs';
        // Recalculate if BMI exists
        if (currentBmi !== null) calculateBMI();
      });

      weightInput.addEventListener('input', function () {
        var val = parseInt(weightInput.value);
        if (val >= 100 && val <= 400) {
          weightSlider.value = val;
          updateSliderVisual(val);
          if (weightPill) weightPill.textContent = val + 'lbs';
        }
      });
    }

    /* --------------------------------------------------------
       5. Weight slider visual
       -------------------------------------------------------- */
    function updateSliderVisual(val) {
      var pct = ((val - 100) / (400 - 100)) * 100;
      if (sliderTrack) {
        sliderTrack.style.background =
          'linear-gradient(to right, var(--c300) 0%, var(--c200) ' + pct + '%, var(--line-2) ' + pct + '%, var(--line-2) 100%)';
      }
      if (sliderThumb) {
        sliderThumb.style.left = 'calc(' + pct + '% - 10px)';
      }
    }

    // Initialize slider visual on load
    if (weightSlider) {
      updateSliderVisual(parseInt(weightSlider.value));
    }

  })();

});
